export default __webpack_public_path__ + "static/media/25.cd2ae0bd.jpg";